import { LitAbility, LitActionResource, LitPKPResource } from '@lit-protocol/auth-helpers';
export const getPKPSessionSig = async (pkp, authMethod, litNodeClient, sessionLength) => {
  console.log('getPKPSessionSig================== ', {
    authMethod,
    pkp,
    expiration: new Date(Date.now() + sessionLength * 1000).toISOString()
  });
  const startTime = new Date().toISOString();
  let capacityDelegationAuthSig;
  if (localStorage.getItem('capacityDelegationAuthSig')) {
    capacityDelegationAuthSig = JSON.parse(localStorage.getItem('capacityDelegationAuthSig'));
  } else {
    const capacityDelegationAuthSigResponse = await fetch(`/api/lit/delegateCapacityCredit?delegateeAddress=${pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress}`);
    capacityDelegationAuthSig = await capacityDelegationAuthSigResponse.json();
    if (capacityDelegationAuthSig.error) {
      throw new Error(capacityDelegationAuthSig.error);
    } else {
      capacityDelegationAuthSig = capacityDelegationAuthSig.capacityDelegationAuthSig;
      localStorage.setItem('capacityDelegationAuthSig', capacityDelegationAuthSig);
    }
  }
  // Set to local storage
  capacityDelegationAuthSig = typeof capacityDelegationAuthSig === 'string' ? JSON.parse(capacityDelegationAuthSig) : capacityDelegationAuthSig;
  console.log('WUJI, time to get capacityDelegationAuthSig', new Date().getTime() - new Date(startTime).getTime());
  const sessionSigsPromise = async () => {
    const startTime = new Date().toISOString();
    const result = litNodeClient.getPkpSessionSigs({
      pkpPublicKey: pkp.publicKey,
      authMethods: [authMethod],
      expiration: new Date(Date.now() + sessionLength * 1000).toISOString(),
      capabilityAuthSigs: [capacityDelegationAuthSig],
      resourceAbilityRequests: [{
        resource: new LitPKPResource('*'),
        ability: LitAbility.PKPSigning
      }, {
        resource: new LitActionResource('*'),
        ability: LitAbility.LitActionExecution
      }]
    });
    console.log('WUJI, time to get session sigs', new Date().getTime() - new Date(startTime).getTime());
    return result;
  };
  const sessionSigs = await sessionSigsPromise();
  console.log('sessionSigs=>', sessionSigs);
  return sessionSigs;
};